export default __webpack_public_path__ + "static/media/icon-panier.f4c8a531.svg";